"use client"
import Footer from "@/components/UI/footer/footer"
import Topbar from "@/components/UI/navbar/topbar"
import React, {useEffect, useState} from "react"
import Lessons from "@/Enums/lessons"
import Exam from "@/components/app/calculator/exams"
import Cert from "@/components/app/calculator/cert"
import Other from "@/components/app/calculator/other"
import Contest from "@/components/app/calculator/contest"
import useToggle from "@/hooks/useToggle"
import ContestsJson from "@/content/contests.json"
import {SEOUtil} from "@/utils/SEOUtil";
import ResultsContext from "@/contexts/ResultsContext";

const Calculator: React.FC = () => {
  const { isTrue, handleToggle } = useToggle(false)
  const [totalPoints, setTotalPoints] = useState(0)

  const [ results, setResults ]  = useState({
    exams: {
      polish: 0,
      math: 0,
      alien: 0
    },
    certs: {
      polish: 0,
      math: 0,
      itemOne: 0,
      itemTwo: 0
    },
    others: {
      distinction: 0,
      volunteer: 0
    },
    contests: new Array(ContestsJson.length).fill(0)
  });

  const sumContestPoints = () => {
      const contestPoints = results.contests.reduce((a, b) => a + b, 0)
      return contestPoints > 18 ? 18 : contestPoints
  }

  useEffect(() => {
    let points: number = 0

    points += results.exams.polish
    points += results.exams.math
    points += results.exams.alien

    points += results.certs.polish
    points += results.certs.math
    points += results.certs.itemOne
    points += results.certs.itemTwo

    points += results.others.distinction
    points += results.others.volunteer

    points += sumContestPoints()

    setTotalPoints(points)
  }, [results]);

  return (
    <ResultsContext.Provider value={{results, setResults}}>
      <SEOUtil name="Kalkulator" url="/app/kalkulator" description="Szybko i prosto oblicz punkty rekrutacyjne do szkoły średniej!" mainEntityOfPage page />
      <Topbar />
      <main className='mb-4'>
        <section className='relative px-0 py-20'>
          <div
            className='container rounded-[40px] w-full px-28 py-20 bg-sectionbg text-white16 mb-28 bg-cover bg-center bg-no-repeat'
            style={{
              backgroundImage:
                "linear-gradient(rgba(34, 34, 34, 0.7),rgba(34, 34, 34, 0.7)), url(/calculator/exams.jpg)",
            }}>
            <h1 className='text-center text-[4.6rem] font-semibold'>
              Egzamin ósmoklasisty
            </h1>
            <hr></hr>
            <form className='w-full mt-10 flex flex-col gap-6 p-6'>
              {[
                ["Język polski", Lessons.POLISH],
                ["Matematyka", Lessons.MATH],
                ["Język obcy", Lessons.ALIEN],
              ].map((item, index) => (
                <Exam id={item[1]} index={index} name={item[0]} key={index} />
              ))}
            </form>
          </div>

          <div
            className='container rounded-[40px] w-full px-28 py-20 bg-sectionbg text-white16 mb-28 bg-cover bg-center bg-no-repeat'
            style={{
              backgroundImage:
                "linear-gradient(rgba(34, 34, 34, 0.7),rgba(34, 34, 34, 0.7)), url(/calculator/certs.png)",
            }}>
            <h1 className='text-center text-[4.6rem] font-semibold'>
              Świadectwo ukończenia szkoły podstawowej
            </h1>
            <hr></hr>
            <div className='w-full mt-10 flex flex-col gap-6 p-6'>
              {[
                ["Język polski", Lessons.POLISH],
                ["Matematyka", Lessons.MATH],
                ["Przedmiot 1*", "itemOne"],
                ["Przedmiot 2*", "itemTwo"],
              ].map((item: any, index) => (
                <Cert name={item[0]} lesson={item[1]} key={index} index={index} />
              ))}
            </div>
            <div className='text-center mt-5'>
              Przedmioty* - Przedmiot wybrany przez szkołę
            </div>
          </div>

          {[
            {
              name: "Świadectwo z wyróżnieniem",
              desc: "Wyróżnienie",
              points: 7,
              id: "distinction"
            },
            {
              name: "Wolontariat",
              desc: "Wolontariat",
              points: 3,
              id: "volunteer"
            },
          ].map((item: any, index) => (
            <Other
              name={item.name}
              desc={item.desc}
              points={item.points}
              key={index}
              id={item.id}
            />
          ))}
          <div className='container rounded-[40px] w-full px-28 py-20 bg-sectionbg text-white16 mb-28'>
            <h1 className='text-center text-[4.6rem] font-semibold'>
              Konkursy
            </h1>
            <hr></hr>
            <div className='w-full mt-10 flex flex-col gap-6 p-6 text-[2.4rem]'>
              <p className='text-center'>
                Czy uzyskałeś tytuł laureata lub finalisty konkursu na minimum
                poziomie powiatu?
              </p>
              <div className='flex justify-between'>
                <button
                  className='w-48 text-2xl font-medium bg-btn text-white p-4 rounded-xl transition-all duration-300 hover:scale-110'
                  onClick={() => {
                    handleToggle()
                    setResults((prev) => ({
                      ...prev,
                      contests: new Array(ContestsJson.length).fill(0)
                    }))
                  }}>
                  {isTrue ? "Nie" : "Tak"}
                </button>
                <input
                  type='text'
                  disabled
                  value={sumContestPoints()}
                  className='bg-white48 w-40 p-1 rounded-xl text-heading text-center outline-none text-3xl points'
                />
              </div>
              <form className={isTrue ? " " : "hidden"}>
                {ContestsJson.map((contest, index) => (
                  <Contest
                    title={contest.title}
                    inputs={contest.inputs}
                    indexContest={index}
                    key={index}
                  />
                ))}
              </form>
            </div>
          </div>
          <div className='fixed flex flex-col items-center bottom-0 left-2/4 translate-x-[-50%] pt-4 px-8 pb-0 rounded-t-[20px] text-center bg-btn shadow-xl shadow-black'>
            <h1 className='md:text-4xl text-3xl text-white16 font-normal mb-3'>Punkty</h1>
            <input
              type='text'
              disabled
              className=' bg-[#ddd] w-40 p-3 rounded-t-xl text-heading text-4xl text-center outline-none'
              value={totalPoints}
            />
          </div>
        </section>
      </main>
      <Footer />
    </ResultsContext.Provider>
  )
}

export default Calculator
